module.exports = __webpack_public_path__ + "media/applicants/icon-checkmarkbox@2x-8daab498.png";